import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// ITEM CODE REPORT RELATED APIs
// ==============================================

// 1. Get Item Category Details All
export const getItemCategoryDetailsAll = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetItemCategoryDetailsAll`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Major Group Code
export const getMajorGroupCode = async (params) => {
    try {
        const { val, txt } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            Val: val || '',
            Txt: txt || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetMajougroupcode?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. View Item Codes Grid Detail
export const viewItemCodesGridDetail = async (params) => {
    try {
        const { icc, mgc } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            ICC: icc || '',
            MGC: mgc || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/ViewItemCodesGridDetail?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. All approved item codes (legacy "Select All" category and the page's first load)
export const getAllItemCodes = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetItemcodedetails`);
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
